import React from "react";

export const FAQData = [
  {
    question: "How do I become a part of ACM?",
    answer:
      "To become a part of ACM, you need to get yourself registered by any team member. For more details, you can write on the website or join the ACM WhatsApp group.",
    open: false
  },
  {
    question: "Do I have to pay for membership of ACM and ACM-W separately?",
    answer:
      "No, you don't have to pay extra for ACM-W. It is a division of ACM but women centric.",
    open: false
  },
  {
    question: "Can I join ACM even if I am not very technically sound?",
    answer:
      "Yes, everyone is welcomed at ACM. The society's aim is to help the person develop his or her technical skills with time.",
    open: false
  },
  {
    question: "What benefits are available for student members?",
    answer: (
      <ul>
        <li>The student members get access to weekly technical newspaper.</li>
        <li>
          ACM is known for publishing research papers, so guidance and support
          is provided regarding the same.
        </li>
        <li>
          Access to all the resources and libraries of ACM, including webinars
          and events conducted.
        </li>
      </ul>
    ),
    open: false
  },
  {
    question: "How long is my membership valid?",
    answer: "The membership is valid till 1 year.",
    open: false
  },
  {
    question: "What are some common student chapter activities?",
    answer: (
      <ul>
        <li>
          The common activities include, attending various sessions for
          different skill building.
        </li>
        <li>Attending special events like SIH guidance, hacktobers, etc.</li>
        <li>Asking for help or guidance when needed.</li>
        <li>Developing lifelong useful skills.</li>
      </ul>
    ),
    open: false
  }
];
